import {BrowserSupport} from '../util/browser-support';

export interface Exporter {

  save(data);

}

export class PDFExporter implements Exporter {

  save(data) {
    BrowserSupport.savePDF(data);
  }

}

export class XLSXExporter implements Exporter {

  save(data) {
    BrowserSupport.saveXlsx(data);
  }

}

export class CSVExporter implements Exporter {

  save(data) {
    BrowserSupport.saveCsvFile(data);
  }

}
